export default __webpack_public_path__ + "static/media/LAIKO-KAFEKOPTION cyprus.b3f6e9b8.png";